import Vue from 'vue'
import VueRouter from 'vue-router'
import cloudPhone from '@/views/cloudPhone/index.vue'

Vue.use(VueRouter)

const CloudPhone = [
    // {
    //     path: '/cloudPhone',
    //     name: 'CloudPhone',
    //     component: cloudPhone
    // },
]

export default CloudPhone
